<template>
  <div class="foto-slider">
    <template v-if="imagem">
      <img v-show="isLoad" :src="url" @load="loaded" />
      <img v-show="isLoad" :src="url" class="animado" @load="loaded" />
      <div class="loading-img-slider" v-show="!isLoad">
        <img id="img" src="@/assets/imgs/puff.svg" alt="Loading...." />
      </div>
    </template>
    <template v-else>
      <img src="@/assets/vivo-consulta/imagens/image_phone_notfound.png" />
      <img src="@/assets/vivo-consulta/imagens/image_phone_notfound.png" class="animado" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'SliderImagem',
  props: {
    imagem: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    url: '',
    isLoad: false,
  }),
  created() {
    this.loadImage();
  },
  methods: {
    loadImage() {
      this.isLoad = false;
      this.url = this.imagem;
    },
    loaded() {
      this.isLoad = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-img-slider {
  width: 100%;
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  & #img {
    height: 60px;
  }
}
.foto-slider {
  height: 220px;
  position: relative;
  & img {
    max-height: 220px;
    z-index: 2;
    width: auto;
  }
}

.animado {
  position: absolute;
  left: 0;
  z-index: 1;
  animation: imagem-destaque 8s infinite;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@keyframes imagem-destaque {
  0% {
    transform: scale(1);
    opacity: 0;
    filter: none;
  }
  10% {
    transform: scale(1);
    opacity: 0.4;
    filter: blur(8px);
  }
  60% {
    transform: scale(1.7);
    opacity: 0;
    filter: blur(16px);
  }
  100% {
    transform: scale(1);
    opacity: 0;
    filter: none;
  }
}
</style>
